import React from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

export const KpiCard = ({ label, value, delta, deltaLabel, icon: Icon, tone = 'primary', suffix }) => {
  const tones = {
    primary: 'bg-primary/10 text-primary',
    accent: 'bg-accent/10 text-accent',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    info: 'bg-info/10 text-info',
  };
  const up = delta !== undefined && delta >= 0;
  return (
    <Card className="p-5 shadow-card hover:shadow-medium transition-smooth border-border/60 bg-card relative overflow-hidden group">
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p className="text-sm font-medium text-muted-foreground">{label}</p>
          <div className="flex items-baseline gap-1.5">
            <h3 className="text-3xl font-display font-bold tracking-tight text-foreground">{value}</h3>
            {suffix && <span className="text-sm text-muted-foreground font-medium">{suffix}</span>}
          </div>
          {delta !== undefined && (
            <div className={cn('flex items-center gap-1 text-xs font-medium', up ? 'text-success' : 'text-destructive')}>
              {up ? <ArrowUpRight className="h-3.5 w-3.5" /> : <ArrowDownRight className="h-3.5 w-3.5" />}
              <span>{up ? '+' : ''}{delta}%</span>
              {deltaLabel && <span className="text-muted-foreground">{deltaLabel}</span>}
            </div>
          )}
        </div>
        {Icon && (
          <div className={cn('h-10 w-10 rounded-lg flex items-center justify-center', tones[tone])}>
            <Icon className="h-5 w-5" strokeWidth={2} />
          </div>
        )}
      </div>
    </Card>
  );
};
